<mat-form-field *ngIf="currenCurrency" [appearance]="appearance">
  <mat-select (selectionChange)="select()" [(value)]="currenCurrency">
    <mat-option *ngFor="let item of curriences" [value]="item.value">{{ item.label }}</mat-option>
  </mat-select>
</mat-form-field>
